import { useMemo } from 'react';
import { useTranslation } from '@bonanza-social/i18n';
import { getPastIsoTimestamp } from '@bonanza-social/toolkit/utils';

function useHistoryOptions() {
  const [t] = useTranslation('account');

  const options = useMemo(
    () => [
      {
        text: t('historyTwentyFourHours'),
        timestamp: getPastIsoTimestamp(24, 'hour'),
      },
      {
        text: t('historySevenDays'),
        timestamp: getPastIsoTimestamp(7, 'day'),
      },
      {
        text: t('historyThirtyDays'),
        timestamp: getPastIsoTimestamp(30, 'day'),
      },
      {
        text: t('historyNinetyDays'),
        timestamp: getPastIsoTimestamp(90, 'day'),
      },
      {
        text: t('historySixMonths'),
        timestamp: getPastIsoTimestamp(6, 'month'),
      },
    ],
    [t],
  );

  const returnObj = useMemo(
    () => ({
      options,
      defaultOption: options[0],
    }),
    [options],
  );

  return returnObj;
}

export default useHistoryOptions;
